import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'; // eslint-disable-line no-unused-vars
import home from './pages/home';
import solutions from './pages/solutions';
import careers from './pages/careers';
import casestudies from './pages/casestudies';
import team from './pages/team';
import contactus from './pages/contactus';
import stef from './pages/stefanblackwood';
import team1 from './pages/bobspencer';
import team2 from './pages/alexwhitney';

class Routing extends Component {
  render() {
    return (
      <div>
        <Route exact path="/" component={home}/>
        <Route path="/solutions" component={solutions}/>
        <Route path="/casestudies" component={casestudies}/>
        <Route path="/careers" component={careers}/>
        <Route path="/ourteam" component={team}/>
        <Route path="/contactus" component={contactus}/>
        <Route path="/stefanblackwood" component={stef}/>
        <Route path="/bobspencer" component={team1}/>
        <Route path="/alexwhitney" component={team2}/>
      </div>
    );
  }
}

export default Routing



// WEBPACK FOOTER //
// ./src/Routing.js